import { useEffect, useState } from 'react';

/**
 * BackToTop — a floating button that appears once you've scrolled down a long
 * (infinite-scroll) list and jumps back to the top. Right-aligned so it never
 * collides with the centered live-event banner; sits above the mobile tab bar.
 */
export default function BackToTop({ threshold = 700 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className="fixed bottom-24 right-4 mb-safe-bot z-40 flex h-12 w-12 items-center justify-center border-2 border-black bg-white font-mono text-xl font-bold text-black shadow-[3px_3px_0_0_#000] transition-colors hover:bg-black hover:text-white lg:bottom-6"
    >
      ↑
    </button>
  );
}
